export const CIRCUIT = 'Circuit';
